<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
  <ds-truncatable [id]="truncatableId">
    <ds-truncatable-part [id]="truncatableId" [minLines]="8">
      <span [innerHTML]="processHtml(metadataValue.value)" class="text-value"></span>
    </ds-truncatable-part>
  </ds-truncatable>
</div>
